(()=>{
 const scope='#MainContent :is(#shopify-section-knp-versa-kg,#shopify-section-knp-versa-mini-kg) .ks-weights-story';
 const paths={
 target:'<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 1v4m0 14v4M1 12h4m14 0h4"/>',
 machine:'<path d="M6 3h12v4H6zM4 7h16v14H4zM9 7v5h6V7M8 17h8M12 12v3"/>',
 scale:'<path d="M4 20h16M12 4v16M4 7h16M4 7l-3 7h6L4 7zm16 0-3 7h6l-3-7z"/><circle cx="12" cy="4" r="2"/>',
 shield:'<path d="M12 2 3 6v6c0 5 9 10 9 10s9-5 9-10V6zM8 12l3 3 5-6"/>',
 bell:'<path d="M8 8V5a4 4 0 0 1 8 0v3M7 8h10l4 10a3 3 0 0 1-3 4H6a3 3 0 0 1-3-4z"/>',
 vest:'<path d="M8 2v4h8V2l5 3-2 6v11H5V11L3 5zM8 12h8v6H8z"/>',
 bar:'<path d="M3 8v8m4-11v14m10-14v14m4-11v8M7 12h10M1 12h2m18 0h2"/>',
 house:'<path d="m2 11 10-9 10 9M5 9v13h14V9M9 22v-8h6v8"/>',
 building:'<path d="M4 22V3h16v19M2 22h20M8 7h2m4 0h2M8 11h2m4 0h2M8 15h2m4 0h2M10 22v-4h4v4"/>',
 pen:'<path d="m4 16 12-12 4 4L8 20l-6 2zM13 7l4 4M4 16l4 4M15 3l2-2 4 4-2 2"/>',
 box:'<path d="m12 2 10 5v10l-10 5-10-5V7zM2 7l10 5 10-5M12 12v10M7 4l10 5v6"/>',
 truck:'<path d="M1 4h14v13H1zM15 9h5l3 4v4h-8"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="18" r="3"/>',
 mail:'<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 6 10 7 10-7"/>',
 phone:'<path d="M4 2h5l2 6-3 2c2 4 4 6 8 8l2-3 4 2v5C10 24 0 14 4 2z"/>',
 clock:'<circle cx="12" cy="12" r="9"/><path d="M12 6v6l4 2"/>',
 people:'<circle cx="9" cy="7" r="3"/><path d="M2 21v-4a7 7 0 0 1 14 0v4M17 4a3 3 0 0 1 0 6M19 13a6 6 0 0 1 3 5v3"/>',
 check:'<path d="m4 12 5 5L20 6"/>'
 };
 const icon=name=>'<svg class="vs-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">'+paths[name]+'</svg>';
 document.querySelectorAll(scope).forEach(root=>{
  const replace=(selector,names)=>root.querySelectorAll(selector).forEach((el,index)=>{
   el.innerHTML=icon(names[index%names.length]);el.setAttribute('aria-hidden','true');
  });
  replace('.feature-icon1',['target','machine','scale','shield']);
  replace('.showcase-row .feature-icon',['bell','vest','bar','bar','house','building','shield','target']);
  replace('.option-icon',['scale','pen','box','truck']);
  replace('.email-icon',['mail','phone']);
  replace('.trust-icon',['clock','people','check']);
  const heading=root.querySelector('.ks-w-editorial__copy h2');
  if(heading&&!heading.querySelector('.vs-highlight')){
   const text=heading.textContent;const word='resized';const index=text.indexOf(word);
   if(index>=0){const span=document.createElement('span');span.className='vs-highlight';span.textContent=word;heading.replaceChildren(document.createTextNode(text.slice(0,index)),span,document.createTextNode(text.slice(index+word.length)));}
  }
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(entry.isIntersecting){entry.target.classList.add('vs-in-view');observer.unobserve(entry.target);}
  }),{threshold:.18});
  root.querySelectorAll('.vpk-mech,.showcase-row,.ks-w-detail-grid article,.feature-card').forEach(el=>observer.observe(el));
 });
})();
